import { Navigate, useParams } from 'react-router-dom'

/** Deep links to `/learn/:topicId/:moduleId` open the unified topic page with a module query. */
export function LearnModulePage() {
  const { topicId, moduleId } = useParams<{ topicId: string; moduleId: string }>()
  if (!topicId || !moduleId) {
    return <Navigate to="/learn" replace />
  }
  return <Navigate to={`/learn/${topicId}?module=${encodeURIComponent(moduleId)}`} replace />
}
